function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var Style = /*#__PURE__*/function () {
  function Style() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var legend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, Style);
    this._name = name;
    this._title = title;
    this._legend = legend;
  }

  /**
   * @method setName
   * Sets name for the style
   *
   * @param {String} name
   *            style name
   */
  return _createClass(Style, [{
    key: "setName",
    value: function setName(name) {
      this._name = name;
    }

    /**
     * @method getName
     * Gets name for the style
     *
     * @return {String} style name
     */
  }, {
    key: "getName",
    value: function getName() {
      return this._name;
    }

    /**
     * @method setTitle
     * Sets title for the style
     *
     * @param {String} title
     *            style title
     */
  }, {
    key: "setTitle",
    value: function setTitle(title) {
      this._title = title;
    }

    /**
     * @method getTitle
     * Gets title for the style
     *
     * @return {String} style title
     */
  }, {
    key: "getTitle",
    value: function getTitle() {
      return this._title;
    }

    /**
     * @method setLegend
     * Sets legendimage URL for the style
     *
     * @param {String} legend
     *            style legend
     */
  }, {
    key: "setLegend",
    value: function setLegend(legend) {
      this._legend = legend;
    }

    /**
     * @method getLegend
     * Gets legendimage URL for the style
     *
     * @return {String} style legend
     */
  }, {
    key: "getLegend",
    value: function getLegend() {
      return this._legend;
    }
  }]);
}();

/**
 * @class Oskari.mapframework.domain.Style
 *
 * Map Layer Style
 */
Oskari.clazz.defineES('Oskari.mapframework.domain.Style', Style, {});